import React, { useEffect, useState } from "react";
import BackButton from "../bars/BackButton";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import RoomFeature from "../../components/RoomFeature";
import Skeleton from "../../components/skeletons/skeleton";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import PageLoader from "../../components/loaders/PageLoader";
import { RoomPageView } from "../../utils/Analytics";

function SpotMyRoom() {
  const reservationId = localStorage.getItem("reservationId");
  const [roomArray, setRoomArray] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [roomLoading, setRoomLoading] = useState(false);
 const [islength,setislength] = useState(false);
  const fetchRooms = async () => {
    setLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/reservedRoomList`,
        data: { reservationId },
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        if (response.data.success) {
          setLoading(false);
          setRoomArray(response.data.data);
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchRoomData = async (roomTypeId) => {
    setRoomLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/reservedRoomByRoomTypeId`,
        data: { roomTypeId },
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        if (response.data.success) {
          setRoomLoading(false);
          setRoomData(response.data.data);
        }
      });
    } catch (error) {
      setRoomLoading(false);
    }
  };

  const seeRoom = (param) => {
    fetchRoomData(param);
  };

  useEffect(() => {
    RoomPageView();
    fetchRooms();
  }, []);


  useEffect(() => {
    if (roomArray?.length === 1) {
      fetchRoomData(roomArray[0]?.id);
      setislength(true);
    }
  }, [roomArray]);


  return (
    <div>
      {!loading ? (
        <div className="spot-my-room">
          {roomData.length == 0 && (
            <div className="section-wrap mx-4">
              <div className="flex items-center space-x-3 pt-6">
                <BackButton />
                <div className="guestName sm:text-center text-left">
                  My Room
                </div>
              </div>
              {roomArray.length != 0 && (
                <div className="mt-4 label">
                  {roomArray.length == 1 ? (
                    <span>
                      You have {roomArray.length} room category under your
                      booking Id
                    </span>
                  ) : (
                    <span>
                      You have {roomArray.length} room categories under your
                      booking Id
                    </span>
                  )}
                </div>
              )}
              {roomArray.length != 0 && (
                <div className="gridTab grid grid-flow-row grid-cols-2  gap-3 gap-x-4 mt-6">
                  {roomArray.map((item, i) => (
                    <div
                      onClick={() => seeRoom(item.id)}
                      key={i}
                      className="room-card sm:h-[200px] h-[160px]"
                    >
                    <div
                        className="img-div w-full h-[80%] rounded-md"
                        style={{
                          backgroundImage: `url(${item.image?.[0]})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center', 
                          backgroundRepeat: 'no-repeat', 
                          width: '100%',
                          height: '80%',
                        }}
                      ></div>
                      <div className="room-name mt-2 truncate">
                        {item.typeName}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {roomData.length != 0 && (
            <RoomFeature roomData={roomData} hide={() => setRoomData([])} lengthcheck = {islength}/>
          )}
        </div>
      ) : (
        <Skeleton type="page" />
      )}

      {roomLoading &&<PageLoader/>}
     </div>
  );
}

export default SpotMyRoom;
